const Post = ({ title, imageURL, date, categories, excerpt, link, author, updateFilter }) => {

    const handleCategoryClick = (event) => {
        event.preventDefault()
        updateFilter('blog-filters__category', event.target.getAttribute('data-category'))
    }

    const postImage = () => {
        if ( typeof imageURL !== undefined && imageURL !== null ) {
            return ( typeof link !== 'undefined' && link !== null )
                ? (
                    <a className="image-link" href={link} aria-label="blog-tease-article">
                        <img class="featured-post-image" src={imageURL} alt="blog-tease-article-image" />
                    </a>
                )
                : <img className="featured-post-image" src={imageURL}/>
        }
    }

    const postCategories = () => {
        return categories
            ? categories.map((category) => {
                if ( typeof category?.name !== 'undefined' ) {
                    return (
                        <>
                            <span className="category badge" onClick={ handleCategoryClick } data-category={category.id}>{ category.name }</span>
                        </>
                    )
                }
            })
            : <></>
    }

    return (
        <article className="tease-post-container">
            <a href={ link } className="post-wrapper">
                <div className="post-image">
                    { postImage() }
                </div>
                <div className="post-content">
                    <div className="post-categories">
                        { postCategories() }
                    </div>
                    <div className="post-title"><h5>{ title }</h5></div>
                    { excerpt && <p className="post-excerpt">{ excerpt }</p> }
                    <div className="post-date-and-extra-info">
                        { date && <div className="post-date">{ date }</div> }
                        <div className="post-extra-info">
                            { author && <span className="post-author strong">By { author }</span> }
                        </div>
                    </div>
                </div>
            </a>
        </article>
    )
}

export default Post